/* Pinky Promise product page: gallery, pack picker, sticky add to cart, video sound */
(function () {
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  function initHero(root) {
    if (!root || root.dataset.ppReady) return;
    root.dataset.ppReady = '1';

    var track = root.querySelector('[data-pp-track]');
    var thumbs = root.querySelectorAll('[data-pp-thumb]');
    var count = root.querySelector('[data-pp-count]');
    if (track) {
      var slides = track.querySelectorAll('[data-pp-slide]');
      var current = 0, raf;
      var setActive = function (i) {
        current = i;
        if (count) count.textContent = i + 1;
        each(thumbs, function (t, n) {
          t.classList.toggle('is-active', n === i);
          t.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
      };
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current) setActive(i);
        });
      }, { passive: true });
      each(thumbs, function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.getAttribute('data-pp-thumb'), 10);
          if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
          setActive(i);
        });
      });
    }


    // pp_sale: countdown to the sale's real end time; hides itself when it ends
    var sale = root.querySelector('[data-pp-sale]');
    if (sale) {
      var end = parseInt(sale.getAttribute('data-end'), 10) * 1000;
      var el = { d: sale.querySelector('[data-pp-d]'), h: sale.querySelector('[data-pp-h]'), m: sale.querySelector('[data-pp-m]'), s: sale.querySelector('[data-pp-s]') };
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var timerId;
      var tick = function () {
        var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (left <= 0) {
          clearInterval(timerId);
          sale.hidden = true;
          try {
            if (!sessionStorage.getItem('pp-sale-reload')) {
              sessionStorage.setItem('pp-sale-reload', '1');
              window.location.reload();
            }
          } catch (err) {}
          return;
        }
        if (el.d) el.d.textContent = pad(Math.floor(left / 86400));
        if (el.h) el.h.textContent = pad(Math.floor(left % 86400 / 3600));
        if (el.m) el.m.textContent = pad(Math.floor(left % 3600 / 60));
        if (el.s) el.s.textContent = pad(left % 60);
      };
      tick();
      timerId = setInterval(tick, 1000);
    }

    var form = root.querySelector('[data-pp-form]');
    var atc = root.querySelector('[data-pp-atc]');
    var atcText = root.querySelector('[data-pp-atc-text]');
    var meta = root.querySelector('[data-pp-sticky-meta]');
    var label = root.getAttribute('data-atc-label') || 'Add to cart';

    if (form) {
      form.addEventListener('change', function (e) {
        var r = e.target;
        if (!r || r.name !== 'id') return;
        each(form.querySelectorAll('.pp-pack'), function (p) { p.classList.toggle('is-selected', p.contains(r)); });
        if (atcText) atcText.textContent = label + ' · ' + r.getAttribute('data-price');
        if (atc) atc.disabled = false;
        if (meta) meta.textContent = r.getAttribute('data-title') + ' · ' + r.getAttribute('data-price');
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          window.history.replaceState(window.history.state, '', u.toString());
        } catch (err) {}
      });
      form.addEventListener('submit', function (e) {
        if (atc) atc.classList.add('is-loading');
        var add = form.querySelector('[data-pp-addon-check]');
        if (!add || !add.checked || !window.fetch) return;
        var main = form.querySelector('input[name="id"]:checked') || form.querySelector('[name="id"]');
        if (!main) return;
        e.preventDefault();
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: +main.value, quantity: 1 }, { id: +add.value, quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw r; window.location.href = root + 'cart'; })
          .catch(function () { add.checked = false; form.submit(); });
      });
      window.addEventListener('pageshow', function () { if (atc) atc.classList.remove('is-loading'); });
    }

    var sticky = root.querySelector('[data-pp-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var btn = sticky.querySelector('[data-pp-sticky-btn]');
      var pastAtc = false, closerVisible = false;
      var update = function () {
        var show = pastAtc && !closerVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (btn) btn.tabIndex = show ? 0 : -1;
        document.body.style.paddingBottom = show ? sticky.offsetHeight + 'px' : '';
      };
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        pastAtc = !e.isIntersecting && e.boundingClientRect.top < 0;
        update();
      }).observe(atc);
      var closer = document.querySelector('[data-pp-closer]');
      if (closer) {
        new IntersectionObserver(function (entries) {
          closerVisible = entries[0].isIntersecting;
          update();
        }).observe(closer);
      }
      if (btn) {
        btn.addEventListener('click', function () {
          if (!form || atc.disabled) return;
          if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
        });
      }
    }
  }

  function initReel(root) {
    if (!root || root.dataset.ppReady) return;
    root.dataset.ppReady = '1';

    // pp_clips: play silent loops only while on screen
    var vids = root.querySelectorAll('[data-pp-autoplay]');
    if (vids.length) {
      var start = function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if ('IntersectionObserver' in window && !reduce) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { if (e.target.preload === 'none') e.target.preload = 'auto'; start(e.target); }
            else e.target.pause();
          });
        }, { rootMargin: '200px 0px' });
        each(vids, function (v) { io.observe(v); });
      } else if (!reduce) {
        each(vids, start);
      }
    }
    var buttons = root.querySelectorAll('[data-pp-sound]');
    each(buttons, function (b) {
      b.addEventListener('click', function () {
        var v = b.parentNode.querySelector('video');
        if (!v) return;
        var turnOn = v.muted;
        each(root.querySelectorAll('video'), function (o) { o.muted = true; });
        each(buttons, function (o) {
          o.setAttribute('aria-pressed', 'false');
          o.setAttribute('aria-label', 'Turn sound on');
        });
        if (turnOn) {
          v.muted = false;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
          b.setAttribute('aria-pressed', 'true');
          b.setAttribute('aria-label', 'Turn sound off');
        }
      });
    });
  }

  function initAll(scope) {
    each(scope.querySelectorAll('[data-pp-hero]'), initHero);
    each(scope.querySelectorAll('[data-pp-reel]'), initReel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();